import { Wrapper, ContentWrapper, FooterH } from "./FooterElements";

const Footer = () => {
    return (
        <Wrapper>
            <ContentWrapper>
                <FooterH>Made with Unsplash API by Aakrut Dabhi</FooterH>
            </ContentWrapper>
        </Wrapper>
    )
}

export default Footer
